export default "__VITE_ASSET__UQyMFDFe__"